import { APIGet } from "api/protocols";
import { CancelToken } from "axios";
import { IProductGroup, IProductGroupProduct } from "pages/guest/models/groups";

const apiVersion = "2024-04";
const adminType = "guest";
const baseUrl = "/" + apiVersion + "/" + adminType + "/product/group";

interface IGetProductGroups {
  facility_id: number;
}

interface IGetProductsInGroup {
  facility_id: number;
  group_id: number[];
}

export async function GetProductGroups(params: IGetProductGroups, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<IProductGroup[]>(baseUrl, params, useGlobalLoader, token);
}

export async function GetGroupProducts(params: IGetProductsInGroup, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<IProductGroupProduct[]>(baseUrl + "/product", params, useGlobalLoader, token);
}
